<template>
  <div class="pay-success__page">
    <div class="page-content">
      <div class="content">
        <div class="content-top">
          <!-- <i class="iconfont icon-zhifuchenggong"></i> -->
          <div class="icon">
            <img src="../../../static/img/success.png" alt="">
          </div>
          <h3 class="sub-title">{{txId == null ? '已登记待审核' : '支付成功'}}</h3>
          <p class="amount">
            <b>￥</b>{{amount}}</p>
        </div>
        <div class="content-bottom">
          <ul class="list-group">
            <li class="list-group-item" v-if="txId != null">
              <span class="name">交易号</span>
              <span class="item">{{txId}}</span>
            </li>
            <li class="list-group-item">
              <span class="name">付款方</span>
              <span class="item">{{orgOwnerName}}</span>
            </li>
            <li class="list-group-item">
              <span class="name">收款方</span>
              <span class="item">{{providerOrgName}}</span>
            </li>
            <!-- <li class="list-group-item">
              <span class="name">系统</span>
              <span class="item">TMS物流系统</span>
            </li> -->
            <li class="list-group-item">
              <span class="name">支付时间</span>
              <span class="item">{{createDate}}</span>
            </li>
            <li class="list-group-item">
              <span class="name">支付方式</span>
              <span class="item">{{paymentTool}}</span>
            </li>
          </ul>
          <div class="button-group">
            <router-link :to="{path: '/'}" tag="el-button">返回</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      txId: "",
      orgOwnerName: "",
      providerOrgName: "",
      amount: "",
      createDate: "",
      paymentTool: ""
    };
  },
  created() {
    setTimeout(() => {
      this.queryOnlinePayment();
    }, 200);
  },
  methods: {
    queryAccount(accountId) {
      this.$request1({
        method: 'GET',
        url: '/success/' + accountId + '',
        withCredentials: true
      })
        .then(response => {
          console.log(response.data);
          if (response.data.success) {
            this.orgOwnerName = response.data.data.orgOwnerName;
            this.providerOrgName = response.data.data.providerOrgName;
          } else {
            this.$notify.error({
              title: "错误",
              message: response.data.message
            });
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    queryOnlinePayment() {
      let id = sessionStorage.getItem("id");
      this.$request1({
        method: 'GET',
        url: '/success/onlinePayment/' + id + '',
        withCredentials: true
      })
        .then(response => {
          console.log(response.data);
          if (response.data.success) {
            let onlinePayment = response.data.data;
            this.queryAccount(onlinePayment.accountId);
            this.txId = onlinePayment.txtId;
            console.log(this.txId);
            this.amount = onlinePayment.amount;
            this.createDate = this.getDate(onlinePayment.txDate);
            switch (onlinePayment.paymentTool) {
              case "AliPay":
                this.paymentTool = "支付宝";
                break;
              case "WeChatPay":
                this.paymentTool = "微信支付";
                break;
              case "Allinpay":
                this.paymentTool = "通联支付";
                break;
              case "Offline_Alipay":
                this.paymentTool = "线下支付宝";
                break;
              case "Rests":
                this.paymentTool = "其他";
                break;
              case "BankTransfer":
                this.paymentTool = "银行转账";
                break;
            }
          } else {
            this.$notify.error({
              title: "错误",
              message: response.data.message
            });
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    add0(m) {
      return m < 10 ? "0" + m : m;
    },
    getDate(time) {
      var date = new Date(time);
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      var d = date.getDate();
      var h = date.getHours();
      var mm = date.getMinutes();
      var s = date.getSeconds();
      return (
        y +
        "-" +
        this.add0(m) +
        "-" +
        this.add0(d) +
        " " +
        this.add0(h) +
        ":" +
        this.add0(mm) +
        ":" +
        this.add0(s)
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.pay-success__page {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;

  .page-content {
    width: 80%;
    padding: 3% 10% 5%;
    background: #fff;
    border-radius: 7px;
    .content {
      .content-top {
        padding-bottom: 15px;
        text-align: center;
        border-bottom: 1px dashed #ccc;
        .iconfont {
          font-size: 80px;
          color: #00b3b6;
        }
        .sub-title {
          margin: 15px 0;
          letter-spacing: 2px;
        }
        .amount {
          font-size: 26px;
          color: #f56c6c;
          b {
            font-size: 16px;
          }
        }
      }
      .content-bottom {
        margin-top: 20px;
        .list-group {
          padding-left: 30%;
          .list-group-item {
            padding: 15px 0;
            .name {
              display: inline-block;
              width: 100px;
            }
          }
        }
        .button-group {
          margin-top: 30px;
          text-align: center;
        }
      }
    }
  }
}
</style>





// WEBPACK FOOTER //
// src/views/recharge/success.vue